import React, { useMemo } from "react";

import { Dispatcher } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const PhonesCellContent: React.FC<PhonesCellContent.Props> = ({ item }) => {
	const content = useMemo(
		() => item.additionalFields?.phones?.join(", ") ?? "",
		[item?.additionalFields],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace PhonesCellContent {
	interface Props {
		item: Dispatcher.Model;
	}
}

export default PhonesCellContent;
